import { api } from '@/lib/api'

export function getEndContractQuote({ contractId }: { contractId: string }) {
  return api.get<{
    earliestEndDate: string
    earliestTerminationPaymentDate?: string
  }>(`/v1/me/contracts/${contractId}/end-contract-quote`)
}
